import { useState } from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";

const quickLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Contact Us", path: "/contact-us" },
  { name: "Track Shipment", path: "/track-shipment" },
];

const social = {
  facebook: "#",
  twitter: "#",
  linkedin: "#",
  instagram: "#",
};

export default function Footer() {
  const year = new Date().getFullYear();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setSubscribed(true);
    setEmail("");
  };

  return (
    <footer className="bg-ink-950 text-slate-400">
      <div className="container-page grid gap-10 py-14 sm:grid-cols-2 lg:grid-cols-3">
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">About Us</h3>
          <p className="mt-4 text-sm leading-relaxed">
            Essaar Logistics moves cargo by road through its hubs, from
            booking to door delivery, with a consignment number you can
            track along the way.
          </p>
          <ul className="mt-5 space-y-2 text-sm">
            <li className="flex items-start gap-2.5">
              <Icon name="pin" className="mt-0.5 h-4 w-4 shrink-0 text-freight-500" />
              <span>4820 Harbor Industrial Pkwy, Savannah, GA 31408</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Icon name="phone" className="h-4 w-4 shrink-0 text-freight-500" />
              <span>+1 (800) 555-0198</span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">Quick Links</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {quickLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="transition-colors hover:text-freight-400">
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">
            Subscribe to Newsletter
          </h3>
          <p className="mt-4 text-sm">Get freight tips and company updates in your inbox.</p>

          <form onSubmit={handleSubscribe} className="mt-4 flex gap-2">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
              className="w-full min-w-0 rounded-md border border-white/10 bg-white/5 px-3.5 py-2.5 text-sm text-white placeholder:text-slate-500 focus:border-freight-500 focus:outline-none"
            />
            <button type="submit" className="btn-primary shrink-0 px-5 py-2.5">
              Subscribe
            </button>
          </form>
          {subscribed && (
            <p className="mt-2 text-xs font-medium text-freight-400">Thanks for subscribing!</p>
          )}

          <h3 className="mt-7 font-display text-sm font-bold uppercase tracking-wider text-white">
            Follow Us
          </h3>
          <div className="mt-4 flex gap-3">
            {[
              ["facebook", social.facebook],
              ["twitter", social.twitter],
              ["linkedin", social.linkedin],
              ["instagram", social.instagram],
            ].map(([icon, href]) => (
              <a
                key={icon}
                href={href}
                aria-label={icon}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-slate-300 transition-colors hover:bg-freight-600 hover:text-white"
              >
                <Icon name={icon} className="h-4 w-4" strokeWidth={1.6} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-page flex flex-col items-center justify-between gap-3 py-5 text-xs text-slate-500 sm:flex-row">
          <p>© {year} Essaar Logistics. All rights reserved.</p>
          <p className="flex gap-4">
            <Link to="/privacy-policy" className="hover:text-slate-300">Privacy Policy</Link>
            <Link to="/terms-conditions" className="hover:text-slate-300">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
